import { useIsOnline } from "@/src/hooks/common/use-is-online";
import React from "react";
import { useTranslation } from "react-i18next";
import { Text, View } from "react-native";

/** Shown while offline: the app is showing cached content and is read-only. */
export default function OfflineBanner() {
  const online = useIsOnline();
  const { t } = useTranslation();
  if (online) return null;
  return (
    <View
      accessibilityRole="alert"
      testID="offline-banner"
      className="mb-2 rounded-lg bg-zinc-800 px-3 py-2"
    >
      <Text className="text-center text-xs text-zinc-200">
        {t("LABEL_OFFLINE_BANNER")}
      </Text>
    </View>
  );
}
